
import { Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent, CustomizerUpsellingComponent } from '@app/customizer/components';
import { PreciousMetalInfoComponent } from '@app/customizer/components/precious-metal-info/precious-metal-info.component';
import { ConfigurationService } from '@services/configuration.service';
import { ModelsService } from '@services/v2/models.service';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { VariantColorModel } from '@models/variant-color';
import { EventsService } from '@services/events.service';
import { ImageService } from '@services/image.service';
import { ComponentVariantModel } from '../../../../_models/component-variant';
import { ComponentVariantChangeModel } from '../../../../_models/component-variant-change';
import { MiscModel } from '../../../../_models/misc-model';
import { DataApiService } from '../../../../_services/data-api.service';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    template: `
    @if (!matchedGrooveColour) {
      <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
        @if (selectableVariants.length) {
          <customizer-colors-auto-update
            [selected]="getSelectedVariant.VariantColor"
            [selectedColorGroup]="currentColorGroup"
            [variants]="selectableVariants"
            [editMode]="state === customizerStateEnum.EDITORDER"
            [matchableColors]="matchableColors"
            [matchableMisc]="miscModels"
            [useColorGroup]="menu.contentGrouping"
            (colorMatchChange)="matchColors($event)"
            (miscMatchChange)="buyGroovePen($event)"
            (selectedColorGroupChange)="onSelectGroup($event)"
            (selectedColorChange)="onSelect($event)"
            [variantOrModelIsNew]="variantOrModelIsNew"
            [matchColor]="menu.matchColor"
            >
          </customizer-colors-auto-update>
        }
      </customizer-component-header>
    }
    <precious-metal-info></precious-metal-info>
    
    @if (matchedGrooveColour) {
      <customizer-upselling
        [miscModel]="matchedGrooveColour"
        [reference]="this.reference"
        [menu]="this.menu"
        (clicked)="closeUpselling()"
      ></customizer-upselling>
    }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerComponentHeaderComponent, CustomizerColorsAutoUpdateComponent, PreciousMetalInfoComponent, CustomizerUpsellingComponent]
})
export class InnerRimColorComponent extends BaseCustomizerComponent {

	selectableVariants: Array<ComponentVariantFromApiModel> = [];
	miscModels: Array<MiscModel> = [];
	matchedGrooveColour: MiscModel | null;

	constructor(
		public override events: EventsService,
		public api: DataApiService,
		public imageService: ImageService,
		private modelsService: ModelsService,
		public override configurationService: ConfigurationService
	) {
		super(events, api, configurationService);
	}

	async initData() {
		this.events.showLoader(true);

		this.selectableVariants = await this.fetchData() ?? [];

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
	}

	async fetchData(): Promise<Array<ComponentVariantFromApiModel> | undefined> {
		const variant = this.getSelectedVariant;
		variant.VariantColorViewed = true;

		this.miscModels = await this.modelsService.getMiscModels();
		const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid, variant.VariantSize?.Uuid);
		await this.RunDisablingSystem(apidata);

		return apidata;
	}

	onSelect(color: VariantColorModel) {
		this.events.showLoader(true);

		const newVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const oldVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		newVariant.VariantColor = color;
		this.updateVariant(new ComponentVariantChangeModel(oldVariant, newVariant, null));
	}

	buyGroovePen(miscModel: MiscModel) {
		this.matchedGrooveColour = miscModel;
	}

	closeUpselling() {
		this.matchedGrooveColour = null;
	}

}
